import './index.css';
import L from 'leaflet';
import serializeStyle from '../serializeStyle';
import classNames from 'classnames';

const rootSize = parseInt(document.documentElement.style.fontSize, 10);

const OPTIONS = {
  latLng: [51.505, -0.094],
  imageUrl: '//imgcdn1.zuzuche.com/m_tantu_image/20170330/3c3029522ef0aa0801cb25839b456423.png',
  size: {
    width: '0.6rem',
    height: '0.6rem'
  },
  index: false,
  message: '',
  className: ''
};



export default function imageMarker(options = {}, markerOptions = {}) {
  options = {...OPTIONS, ...options};

  let size = serializeStyle(options.size);
  let bg = serializeStyle({
    'background-image': `url(${options.imageUrl})`
  });
  let className = classNames('pic', options.className);

  // 索引
  let index = '';
  if (options.index !== false) {
    index = `<div class="index"><em>${options.index}</em></div>`;
  }

  // divIcon 实例
  let icon = L.divIcon({
    iconSize: [
      rootSize * parseFloat(options.size.width),
      rootSize * parseFloat(options.size.height)
    ],
    className: classNames('component-map-image-marker', {
      active: options.active
    }),
    html: `<div style="${size}" data-poi-uid="${options.source && options.source.poi_uid}">
            <div class="${className}" style="${bg}">${index}</div>
          </div>`
  });

  markerOptions.icon = icon;
  let marker = L.marker(options.latLng, markerOptions);
  marker.latLng = options.latLng;

  if (options.message) {
    marker.on('add', function () {
      marker.bindPopup(options.message, {
        closeButton: false,
        // offset: [14, 12],
        className: 'component-map-image-marker-popup',
        autoClose: false,
        closeOnClick: false
      }).openPopup();
    });
  }

  marker.active = function () {
    marker.reset();

    let className = marker._icon.className;
    marker._icon.className = className + ' active';
  };

  marker.reset = function () {
    let className = marker._icon.className;
    marker._icon.className = className.replace(' active', '');
  };


  marker.markerOptions = options;

  return marker;
}





// WEBPACK FOOTER //
// ./src/components/Map/imageMarker/index.js